import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
export const costsGridColumns = () => [

    {
        field: 'description',
        headerName: 'Cost Description',
        cellRenderer: 'agGroupCellRenderer',
        wrapText: true,
        minWidth:250,
        flex: 1,
    },
    {
        field: 'fromActivity',
        headerName: 'From Activity',
        width: 135,
    },
    {
        field: 'toActivity',
        headerName: 'To Activity',
        width: 135,
    },
    {
        field: 'variantType',
        headerName: 'Variant Type',
        width: 120,
    },
    {
        field: 'issueType',
        headerName: 'Work Type',
        width: 120,
    },
    {
        field: apiProvider.getEntityUpper() + 's',
        headerName: apiProvider.getEntityUpper() + 's',
        filter: 'agNumberColumnFilter',
        width: 100,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },    
    {
        field: 'events',
        headerName: 'Events',
        filter: 'agNumberColumnFilter',
        width: 100,
        type: 'rightAligned',
        hide: false,
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },  
    {
        field: 'costType',
        headerName: 'Actual Cost Calculation',
        wrapText: true,
        width: 140,
    },
    {
        field: 'forecast_cost_calculation',
        headerName: 'Forecast Cost Calculation',
        wrapText: true,
        width: 140,
    },
    {
        field: 'cost',
        headerName: 'Cost',
        hide: false,
        width: 90,
        aggFunc: 'sum',
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatCost({ cost: value  }),
    },
    {
        field: 'actual_cost',
        headerName: 'Actual Cost',
        hide: false,
        width: 100,
        aggFunc: 'sum',
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatCost({ cost: value  }),
    },
    {
        field: 'forecast_cost',
        headerName: 'Forecast Cost',
        hide: false,
        width: 100,
        aggFunc: 'sum',
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatCost({ cost: value  }),
    },
    {
        field: 'cost_saving',
        headerName: 'Cost Savings',
        hide: false,
        width: 100,
        type: 'rightAligned',
        aggFunc: 'sum',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatCost({ cost: value  }),
    },
    {
        field: 'perc_cost_saving',
        headerName: '% Cost Saving',
        hide: true,
        width: 90,
        type: 'rightAligned',
        aggFunc: 'sum',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            formatPercentage( value, 2 ),
    },

    {
        field: 'type',
        headerName: 'Type',
        wrapText: true,
        hide: true,
        width: 100,
    },
    {
        field: 'costID',
        headerName: 'ID',
        hide: true,
        suppressColumnsToolPanel: true
    },

];


export function formatPercentage(x, decimals) {
    if (x === -1) return ''
    else return (x * 100).toFixed(decimals) + '%';
}